
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 10.809l-.447-.224a.5.5 0 00.568.709l-.121-.485zm8.5-4.22a3.719 3.719 0 01-3.719 3.72v1a4.719 4.719 0 004.72-4.72h-1zm-7.437 0A3.719 3.719 0 016.28 2.872v-1A4.719 4.719 0 001.563 6.59h1zM6.28 2.872a3.719 3.719 0 013.72 3.719h1A4.719 4.719 0 006.28 1.87v1zm0 7.438c-.283 0-.625-.108-1.034-.253-.19-.067-.399-.144-.592-.201a2.24 2.24 0 00-.624-.109v1c.067 0 .175.019.339.067.161.048.336.112.542.186.384.136.886.31 1.37.31v-1zm-2.25-.563c-.085 0-.193.018-.275.032-.097.017-.214.04-.342.067-.256.054-.568.125-.868.196-.301.07-.593.141-.809.194l-.26.064-.072.018-.02.005a.152.152 0 00-.006.002l.121.485.121.485h.002a.06.06 0 00.004-.002l.02-.004a20.352 20.352 0 01.328-.082c.214-.052.503-.122.8-.192.297-.07.6-.14.845-.19.123-.027.227-.047.307-.061.095-.017.12-.017.104-.017v-1zM1.5 10.81l.447.223.001-.001.002-.005a2.505 2.505 0 00.036-.072 19.352 19.352 0 00.395-.862c.109-.253.22-.53.305-.786.08-.238.158-.517.158-.747h-1c0 .051-.027.193-.106.43a9.516 9.516 0 01-.276.709 18.682 18.682 0 01-.4.87l-.007.013-.002.003v.001l.447.224zm1.344-2.25c0-.34-.083-.762-.15-1.107-.075-.383-.131-.676-.131-.862h-1c0 .307.084.717.15 1.054.073.376.13.692.13.915h1z","fill":"#748190"}})])
          )
        }
      }
    